import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthHeaderService } from 'app/shared/auth-header.service';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs-compat';
import { retry } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class DeveloperService {

  
  

  constructor(private http: HttpClient,  private miscService: MiscService, private authHeaderService: AuthHeaderService,) { }

  generatePublicKey = () => this.http.get(`${environment.TRANSACTION_URL}/merchant/public-key?merchant_id=${this.miscService.getMerchantDetails().merchant_id}`).pipe(retry(3))

  registerWebhook = (data:{}) => this.http.post(`${environment.API_URL}/updateUser/${this.miscService.getMerchantDetails().merchant_id}`, data).pipe(retry(3))

  getTransactionLogs = (data: any): Observable<any> => {
    const paramsData = {
      startDate: data.startDate ? data.startDate : "2025-01-01",
      endDate: data.endDate ? data.endDate : "",
      pageLimit: data.limit ? data.limit : 50,
      pageNumber: data.pageNumber ? data.pageNumber : 0,
      reference: data.reference ? data.reference : "",
      status: data.status ? data.status : "",
      type: data.type ? data.type : "",
      download: data.download ? data.download : false
    }
    const params = new HttpParams()
      .set('startDate', paramsData.startDate)
      .set('endDate', paramsData.endDate)
      .set('type', paramsData.type)
      .set('reference', paramsData.reference)
      .set('limit', paramsData.pageLimit)
      .set('page', paramsData.pageNumber)
      .set('status', paramsData.status)
      .set('download', paramsData.download);
    const options = data.download ? { params, responseType: 'blob' as 'json' } : { params };
    return this.http.get(`${environment.API_URL3}/merchant/transactions/fetch-api-transaction-log`, options).pipe(retry(3));
  }


   fetchApiKey = (): Observable<any> => {
      const xAuthHeader = this.authHeaderService.generateAuthHeader({});
      const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
  
      return this.http.get(`${environment.API_URL2}/xas/v1/merchants/api-access`, {headers});
    }

    fetchWebhookSecret = (rotate?: boolean): Observable<any> => {
      const xAuthHeader = this.authHeaderService.generateAuthHeader({});
      const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
  
      const initialUrl = `${environment.API_URL2}/xas/v1/merchants/webhook-secret`;
      const finalUrl = rotate ? `${initialUrl}?rotate=true` : initialUrl;

      return this.http.get(finalUrl, { headers });
    }

    validateApiKey = (): Observable<any> => {
      const xAuthHeader = this.authHeaderService.generateAuthHeader({});
      const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
  
      return this.http.get(`${environment.API_URL2}/xas/v1/merchants/api-access`, {headers});
    }

    rotateApi = (): Observable<any> => {
      const xAuthHeader = this.authHeaderService.generateAuthHeader({});
      const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
  
      return this.http.patch(`${environment.API_URL2}/xas/v1/merchants/api-access/refresh-key`,{},{headers});
    }

  // downloadTransactions(
  //     merchant_id: string,
  //     channel_id?: string,
  //     product_id?: string,
  //     start_date?: string,
  //     end_date?: string,
  //     search_query?: string,
  //     filter_type?: string,
  //     // trans_type?: string,
  //     gift_aid_process?:boolean | string | null,
  //   ): Observable<any> {
  //     let params = new HttpParams()
  //     params = params.append('format', 'xlsx')
  //     if(channel_id)
  //       params = params.append('channel_id', channel_id)
  //     if(product_id)
  //       params = params.append('product_id', product_id)
  //     if(start_date)
  //       params = params.append('start', start_date)
  //     if(end_date)
  //       params = params.append('end', end_date)
  //     if(search_query)
  //       params = params.append('search', search_query)
  //     // if(trans_type)
  //     //   params = params.append('trans_type', trans_type)
  //     if (filter_type !== 'GIFTAID'){
  //       params = params.append('filter_type', filter_type)
  //     } else{
  //       if(gift_aid_process == 'true'){
  //         params = params.append('gift_aid', true)
  //         params = params.append('gift_aid_process', true)
  //       } else if (gift_aid_process == 'false'){
  //         params = params.append('gift_aid', true)
  //         params = params.append('gift_aid_process', false)
  //       } else if (gift_aid_process == null){
  //         params = params.append('gift_aid', true)
  //       }
  //     }
  //     const headers = new HttpHeaders({
  //       'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });
  //     return this.http.get(`${environment.API_URL2}/transactions-service/merchant/transactions/${merchant_id}`, {params, headers, responseType: 'blob'}).pipe(retry(1))
  //   }
}
